class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}
customElements.define('mini-cart', MiniCart);
// === Bert & Hugo: Free shipping popup (SL 45€ / DE 49€) ===
(function () {
  // 1) Jezik -> prag za free shipping
  const lang = (document.documentElement.lang || window.Shopify?.locale || 'de').toLowerCase();
  const isSL = lang.startsWith('sl');
  const threshold = isSL ? 45 : 49;
  const maxDiff = 10; // popup pokažemo samo, če manjka do 10 €

  // 2) Copy (SL / DE)
  const COPY = isSL ? {
    title: "Še 1 majhen korak do brezplačne dostave",
    body: "Dodaj še 1× Objem za tačke",
    priceline: "Samo 21,90 €",
    b1: "Brezplačna poštnina",
    b2: "Zaloga do pomladi",
    add: "Dodaj & nadaljuj",
    skip: "Preskoči → na blagajno"
  } : {
    title: "Nur 1 kleiner Schritt bis zum Gratisversand",
    body: "Füge noch 1× Pfoten-Umarmung hinzu",
    priceline: "Nur 15,90 €",
    b1: "Gratisversand",
    b2: "Vorrat bis zum Frühling",
    add: "Hinzufügen & weiter",
    skip: "Überspringen → zur Kasse"
  };

  // 3) Popup samo 1x na sejo
  function alreadyShown() {
    return sessionStorage.getItem('bh_fs_shown') === '1';
  }
  function markShown() {
    sessionStorage.setItem('bh_fs_shown', '1');
  }

  // 4) Ustvari popup (če še ne obstaja)
  function ensureModal() {
    if (document.getElementById('bh-fs-modal')) return;

    const modal = document.createElement('div');
    modal.id = 'bh-fs-modal';
    modal.style.cssText =
      'display:none; position:fixed; inset:0; background:rgba(0,0,0,.55); align-items:center; justify-content:center; z-index:999999;';

    modal.innerHTML = `
      <div style="background:#fff; width:min(92vw,420px); border-radius:18px; padding:18px 16px;">
        <div id="bh_fs_title" style="font-weight:700; font-size:16px; margin-bottom:10px;"></div>
        <div id="bh_fs_body" style="margin-bottom:8px;"></div>
        <div id="bh_fs_price" style="font-weight:700; margin-bottom:10px;"></div>
        <div style="margin-bottom:14px;">
          <div id="bh_fs_b1" style="margin:6px 0;"></div>
          <div id="bh_fs_b2" style="margin:6px 0;"></div>
        </div>
        <button type="button" id="bh_fs_add"
          style="width:100%; padding:12px 14px; border-radius:12px; border:0; font-weight:700; cursor:pointer;">
        </button>
        <button type="button" id="bh_fs_skip"
          style="width:100%; margin-top:10px; padding:10px 14px; border-radius:12px; background:transparent; border:1px solid rgba(0,0,0,.15); cursor:pointer;">
        </button>
      </div>
    `;

    document.body.appendChild(modal);

    // klik na ozadje zapre popup
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.style.display = 'none';
    });

    // gumbi
    document.addEventListener('click', (e) => {
      if (e.target && e.target.id === 'bh_fs_skip') {
        modal.style.display = 'none';
        window.location.href = '/checkout';
      }
      if (e.target && e.target.id === 'bh_fs_add') {
        // zaenkrat samo nadaljuje na checkout
        window.location.href = '/checkout';
      }
    });
  }

  function openModal() {
    return; // POPUP OFF (SL + DE)
    ensureModal();
    const m = document.getElementById('bh-fs-modal');
    if (!m) return;

    document.getElementById('bh_fs_title').textContent = COPY.title;
    document.getElementById('bh_fs_body').textContent = COPY.body;
    document.getElementById('bh_fs_price').textContent = COPY.priceline;
    document.getElementById('bh_fs_b1').textContent = COPY.b1;
    document.getElementById('bh_fs_b2').textContent = COPY.b2;
    document.getElementById('bh_fs_add').textContent = COPY.add;
    document.getElementById('bh_fs_skip').textContent = COPY.skip;

    m.style.display = 'flex';
    markShown();
  }

  async function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
  }

  function qualifies(cart) {
    return false; // POPUP OFF - ne blokiraj checkouta
    const total = cart.total_price / 100;
    const diff = threshold - total;

    if (diff <= 0) return false;      // že ima free shipping
    if (diff > maxDiff) return false; // manjka preveč
    if (alreadyShown()) return false; // samo 1x na sejo
    return true;
  }

  // 5) Prestrezemo klik na checkout v MINI CART
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;

    e.preventDefault();

    try {
      const cart = await getCart();
      if (qualifies(cart)) {
        openModal();
      } else {
        window.location.href = '/checkout';
      }
    } catch (err) {
      window.location.href = '/checkout';
    }
  });
})();
